import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function getAllSalesAgents(callback) {
	try {
		await firebaseRef
			.ref('/kavtek_sales_agents/' + PROJECT_CODE.projectCode)
			.once('value', (snapshot) => {
				let salesAgentObj = snapshot?.val();
				let salesAgentObjkey = Object?.keys(salesAgentObj);
				let salesAgentArr = [];

				salesAgentObjkey?.forEach((key) => {
					salesAgentArr.push({
						salesAgentID: salesAgentObj[key].createrID,
						salesAgentName: salesAgentObj[key].name,
						email: salesAgentObj[key].email,
					});
				});
				callback(salesAgentArr);
			});
	} catch (err) {
		callback([]);
	}
}
